import React, {useEffect, useState} from 'react';
import {InputSearch} from "./style/InputStyle";
import styled from "styled-components";
import {nonObject} from "../commonmethod/CommonMethod";


export const Label = styled.span`
    display: ${props => props.mobile ? 'block' : ''};
    margin-right: 10px;
    line-height: 30px;
`;

export const BtnSearchBtn = styled.button`
    cursor: pointer;
    border: 1px solid #d0d0d0;
    line-height: 32px;
    padding: 0 15px;
    text-align: center;
    height: 32px;
    background: ${(props) => props.background || 'var(--tehemeDark)'};
    color: ${(props) => props.color || 'white'};
    display: ${(props) => props.display || 'block'};
    border-radius: 4px;

    &:active {
        transform: scale(0.95); /* 클릭 시 크기 축소 */
    }

    &:hover {
        border: 1px hsl(240, 2%, 22%) solid;
    }
`;
/**
 * Listener : 검색 실행 메서드
 * setSearchObject : 검색조건을 담아줄 메서드
 * */


function SearchTextTemp({title, handleSearch, placeHolder, value}) {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const [searchTxt, setSearchTxt] =useState(value?.searchTxt ??'');

    // 엔터키 입력 시 검색 실행
    const handleOnKeyPress = e => {
        if (e.key === 'Enter') {
            nonObject(value, searchTxt, handleSearch, "searchTxt")
            // handleSearch({ searchTxt });
        }
    };

    const inputListener = e => {
        setSearchTxt(e.target.value);
    };
    useEffect(() => {
        setSearchTxt(value?.searchTxt ?? '');
    }, [value]);
    useEffect(() => {
        const handleKeyDown = event => {
            if (event.ctrlKey && event.shiftKey && (event.key === 'F' || event.key === 'f')) {
                const this_input = document.getElementById("this_input");
                if (this_input) {
                    this_input.focus();
                }
            }
        };
        // 이벤트 리스너 등록
        document.addEventListener('keydown', handleKeyDown);

        // 컴포넌트 언마운트 시 이벤트 리스너 제거
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);


    return (
        <InputSearch
            className="search-text-input"
            value={searchTxt}
            mobile={isMobile ? "true" : undefined}
            placeholder={placeHolder ?? "ctrl + shift + F"}
            id={"this_input"}
            onChange={inputListener}
            onKeyPress={handleOnKeyPress}
        />
    );
}

export default SearchTextTemp;